export default function FormLabel(theme: any) {
  return {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: '#FF4842'
        }
      }
    }
  };
}
